// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_pc-8";
export var editMode = "_pc-3";
export var headerRow = "_pc-a";
export var headerTitle = "_pc-b";
export var product = "_pc-1";
export var productDetails = "_pc-5";
export var productDivider = "_pc-7";
export var productImage = "_pc-2";
export var productInfo = "_pc-4";
export var productTitle = "_pc-6";
export var strikethrough = "_pc-9";
export var upsellProductsCard = "_pc-0";